import { render, staticRenderFns } from "./NotesCard.vue?vue&type=template&id=f84b9274&scoped=true"
import script from "./NotesCard.vue?vue&type=script&lang=js"
export * from "./NotesCard.vue?vue&type=script&lang=js"
import style0 from "./NotesCard.vue?vue&type=style&index=0&id=f84b9274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84b9274",
  null
  
)

export default component.exports